import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"hide-on-print",attrs:{"depressed":"","color":"primary","block":_vm.block ? _vm.block : false},on:{"click":_vm.handlePrint}},[_c(VIcon,{staticClass:"mr-1",attrs:{"dark":""}},[_vm._v("print")]),_vm._v("\n  Print\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }